export const TYPE_COLUMN_TOTAL = 'column-total';
export const TYPE_COLUMN_HIGH_CHART = 'column-high-chart';
export const TYPE_COLUMN_TABLE = 'column-table';

export interface ITableResultData {
    columns: any[];
    rows: {[key: string]: string|number}[];
}

export type IConfigSchema  = {
    titleSection?: {
        title: string
    };
    rows: {
        col?: number;
        columns: {
            title?: string;
            typeChart: string;
            chartType?: string;
            transformData: Highcharts.Options|number|string|ITableResultData;
        }[]
    }[];
}[];